import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button, RadioButton } from 'ncoded-component-library';
import { CollapsibleSection } from 'components/CollapsibleSection';
import utils from 'utils';
import FileSecurityFeatureList from '../FileSecurityFeatureList';
import { FileSecurityLevelListItem } from '../FileSecurityFeatureList/FileSecurityFeatureList.component';

import './FileSecurityLevelRow.styles.scss';

type FileSecurityLevelRowProps = {
  className?: string;
  title: string;
  description: string;
  list: FileSecurityLevelListItem[];
  isSelected: boolean;
  isNotifyAction?: boolean;
  disabled?: boolean;
  onSelect: () => void;
};

const FileSecurityLevelRow: React.FC<FileSecurityLevelRowProps> = (props) => {
  const {
    className,
    title,
    description,
    list,
    isSelected,
    children,
    isNotifyAction = false,
    disabled = false,
    onSelect,
  } = props;

  const classes = classNames(
    'file-security-level-row',
    'white-panel',
    { selected: isSelected, disabled },
    className,
  );

  const { t } = useTranslation();

  const handleSelect = useCallback(() => {
    if (disabled) return;

    onSelect();
  }, [disabled, onSelect]);

  return (
    <CollapsibleSection
      className={classes}
      open={isSelected}
      onAnimationEnd={utils.noop}
      onTriggerClick={handleSelect}
      trigger={
        <div className="file-security-level-row__trigger">
          <RadioButton checked={isSelected} />

          <div className="file-security-level-row__trigger__text">
            <p className="title">{t(title)}</p>
            <p className="description">{t(description)}</p>
          </div>

          {isNotifyAction && <Button>{t('notifyMe')}</Button>}
        </div>
      }
    >
      <FileSecurityFeatureList className="feature-list" list={list} />

      {children}
    </CollapsibleSection>
  );
};

export default FileSecurityLevelRow;
